/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, required: NonNullable<unknown> }} Version_Gate_Feedback_MultiInputs */



/**
* | output |
* | --- |
* | "{label}: one or more are on version < {required}" |
*
* @param {Version_Gate_Feedback_MultiInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const version_gate_feedback_multi = /** @type {((inputs: Version_Gate_Feedback_MultiInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Version_Gate_Feedback_MultiInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.label}: one or more are on version < ${i?.required}`)
	return /** @type {LocalizedString} */ (`${i?.label} : une ou plusieurs sont en version < ${i?.required}`)
});